import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Provider } from "react-redux";
import userContext from "./utils/userContext";
import appStore from "./utils/appStore";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


function App() {
  const [userName, setUserName] = useState("");

  return (
    <Provider store={appStore}>
      <userContext.Provider value={{ currentUser: userName, setUserName}}>
        <Header />
        <Outlet />
        <Footer />
      </userContext.Provider>
    </Provider>
  );
}

export default App;
